import { action, computed, observable } from 'mobx';

import * as SamplesAPI from '~api/SamplesAPI/SamplesAPI';

import { ISample } from '~domain/entities/Sample/ISample';
import { ILoyalty } from '~domain/entities/Loyalty/ILoyalty';

export class SamplesRepository {
    @observable private _samples: ISample[];
    @observable private _loyalty: ILoyalty;
    @observable private _isLoading: boolean = false;

    @computed public get samples(): ISample[] {
        return this._samples;
    }

    @computed public get loyalty(): ILoyalty {
        return this._loyalty;
    }

    @computed public get isLoading() {
        return this._isLoading;
    }

    @action getSamples = async () => {
        this._isLoading = true;
        const _offers = await SamplesAPI.getSamples();
        this._samples = _offers.samples;
        this._loyalty = _offers.loyalty;
        this._isLoading = false;

        return {
            ...this._samples,
            ...this._loyalty
        };
    };
}
